import { DropdownItem } from ".";

export const corporateInterestItems: DropdownItem[] = [
  {
    label: 'Client Interested',
    value: 'client_interested',
    bgColor: '#E1EBFC',
    textColor: '#165FE3',
  },
  {
    label: 'Client Not Interested',
    value: 'client_not_interested',
    bgColor: '#EBDCD9',
    textColor: '#8A544A',
  },
  {
    label: 'Demo Scheduled',
    value: 'demo_scheduled',
    bgColor: '#D5FFFF',
    textColor: '#10AFBE',
  },
  {
    label: 'Demo Followup',
    value: 'demo_followup',
    bgColor: '#F6ECFF',
    textColor: '#9165B8',
  },
  {
    label: 'Maxx Portal',
    value: 'maxx_portal',
    bgColor: '#F3FBD4',
    textColor: '#6B8700',
  },
  {
    label: 'Maxx Portal - Activated',
    value: 'maxx_portal_activated',
    bgColor: '#DFFFD6',
    textColor: '#00A82D',
  },
];

export const partnerInterestItems: DropdownItem[] = [
  {
    label: 'Partner Interested',
    value: 'partner_interested',
    bgColor: '#E1EBFC',
    textColor: '#165FE3',
  },
  {
    label: 'Partner Not Interested',
    value: 'partner_not_interested',
    bgColor: '#EBDCD9',
    textColor: '#8A544A',
  },
  {
    label: 'Demo Scheduled',
    value: 'demo_scheduled',
    bgColor: '#D5FFFF',
    textColor: '#10AFBE',
  },
  {
    label: 'Demo Followup',
    value: 'demo_followup',
    bgColor: '#F6ECFF',
    textColor: '#9165B8',
  },
  {
    label: 'Maxx Portal',
    value: 'maxx_portal',
    bgColor: '#F3FBD4',
    textColor: '#6B8700',
  },
  {
    label: 'Maxx Portal - Activated',
    value: 'maxx_portal_activated',
    bgColor: '#DFFFD6',
    textColor: '#00A82D',
  },
  {
    label: 'Credentials Shared',
    value: 'Credentials Shared',
    bgColor: '#F2F2F2',
    textColor: '#000000',
  }
];
